<template>
  <div class="p-6">
    <div class="h-auto flex flex-col gap-2">
      <div class="font-semibold flex">
        Changelog
      </div>
      <div
        class="rounded-2xl border flex items-center px-5 py-3 min-h-12 border-border-color bg-gray-02/20"
      >
        <div class="flex flex-col items-start changelog-text-div">
          <template v-if="hasEntries">
            <div
              v-for="(line, index) in changelog"
              :key="index"
              class="changelog-text"
            >
              {{ line }}
            </div>
          </template>
          <div
            v-else
            class="changelog-text"
          >
            Não há mudanças.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  const props = defineProps<{
    changelog: string[];
  }>();

  const hasEntries = computed(() => (props.changelog?.length ?? 0) > 0);
</script>
